import BuilderBriefChannelsInstagramPaidPartership, {
  IInstagramPaidPartershipResults as IInstagramPaidPartershipResultsType,
} from './PaidPartnership'
import BuilderBriefChannelsInstagramPaidPartershipTip from './Tip'

export type IInstagramPaidPartershipResults = IInstagramPaidPartershipResultsType
export { BuilderBriefChannelsInstagramPaidPartershipTip }
export default BuilderBriefChannelsInstagramPaidPartership
